import api from "./api";

const KEY = "cc_funnel_sid";
const UTM_KEY = "cc_utm";
const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign"];

export function sessionId() {
  let sid = localStorage.getItem(KEY);
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY, sid);
  }
  return sid;
}

/* First-touch UTM capture: read once from the URL, keep for the session so later events/postings carry the source. */
export function captureUtm(search) {
  try {
    const q = new URLSearchParams(search || window.location.search);
    const found = {};
    UTM_FIELDS.forEach((k) => { const v = q.get(k); if (v) found[k] = v.slice(0, 60); });
    if (Object.keys(found).length) localStorage.setItem(UTM_KEY, JSON.stringify(found));
  } catch (e) { /* ignore */ }
}

export function getUtm() {
  try { return JSON.parse(localStorage.getItem(UTM_KEY) || "null") || null; } catch (e) { return null; }
}

export function track(event, props) {
  try {
    const utm = getUtm();
    api.post("/track", { event, session_id: sessionId(), props: { ...(utm || {}), ...(props || {}) } }).catch(() => {});
  } catch (e) { /* never block UX on analytics */ }
}
